module.exports = __webpack_public_path__ + "static/img/detail_fy03.7b8b21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail_fy03.png
// module id = hBgQ
// module chunks = 19